import { Size, TextStyle } from "../../domain/drawing";

export interface ITextSizeMeasure {
  measure(text: string, textStyle: TextStyle): Size;
}

export function instanceOfITextSizeMeasure(instance: any): instance is ITextSizeMeasure {
  return instance
    && (instance.measure !== undefined);
}
